import { EOrderType } from "../types";
import type { TOrderType, TFilter } from "../types";

const defaultSorter: TOrderType = "empfohlen";
export const emptyFilterStore: TFilter = {
  filter: {},
  reset: {},
  order: defaultSorter,
  reducer: new Map(),
  indicator: new Map(),
};

export const getAllowedSorter = (which: EOrderType): TOrderType => {
  const allowed = Object.values(EOrderType);
  if (allowed.includes(which)) return which;
  return defaultSorter;
};
